import React from 'react';
import GlobalHeader from './components/layout/GlobalHeader';
import Footer from './components/layout/Footer';
import LandingPage from './pages/LandingPage';
import './styles.css';

/**
 * App - Main application component
 *
 * Uses Tactical Precision components without routing
 * When react-router-dom is installed, this can be updated to support /ui-kit route
 */
function App() {
  return (
    <div className="App">
      <GlobalHeader />
      <LandingPage />
      <Footer />
    </div>
  );
}

export default App;
